import React from 'react';
import './Loader.css'; // Import the CSS file

const Loader = () => {
    return (
        <div className="loader-container">
            <img src="/bafblue.png" alt="Logo" className="loader-logo" />
        </div>
    );
}

export default Loader;
